const colors = {
  white: ['#f9fbfd', '#eff4f9', '#e3e9ef', '#ccd3db', '#abb4be'],
  dark: ['#6b7b95', '#4a5974', '#36435c', '#242e42', '#181d28'],
  blue: ['#c7deef', '#7eb8dc', '#329dce', '#3385b0', '#326e93'],
  green: ['#c4e6d4', '#a2d8bb', '#55bc8a', '#479e88', '#3b747a'],
  yellow: ['#ffe1be', '#ffc781', '#f5a623', '#e0992c', '#8d663e'],
  red: ['#fae7e5', '#ea8573', '#ca2621', '#ab2F29', '#8c3231'],
};

export default colors;
